/**
 * @author silence
 * @desc:注册登录页面请求借口
 * */

import request from '@/utils/ajax';


export function initData(url, params) {
  return request({
    url: url,
    method: 'get',
    params,
  })
}

export function LoginPost(data) {
	return request({
	    url: '/wx/sys/login',
      method: 'POST',
		data,
	});
}

export function queryMenuAndPermission() {
  return request({
    url: '/wx/sys/menu/nav',
    method: 'get',
  });
}

export function queryUserInfo() {
  return request({
    url: '/wx/sys/user/info',
    method: 'get',
  });
}

export function queryPublicAccountList(){
  return request({
    url: '/wx/manage/wxAccount/list',
    method: 'get',
  });
}

export function editPass(data){
  return request({
    url: '/wx/sys/user/password',
    method: 'post',
    data: data,
  })
}

/**
 *
 * @param data: avatar: 头像url
 * @returns {*}
 */
export function uploadAvatar(data){
  return request({
    url: '/wx/sys/user/avatar',
    method: 'put',
    data: data,
  })
}

export function queryPushTab(){
  return request({
    url: '/wx/manage/spiderArticlePublish/channelTypes',
    method: 'get',
  })
}

